import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { SingleServicioComponent } from './single-servicio/single-servicio.component';



const appRoutes: Routes = [


  {
    path: 'index',
    component: HomeComponent,
  },

  {
    path: 'servicio/:id',
    component: SingleServicioComponent,
  },

  {
    path: '**',
    redirectTo: 'index'
  }


];

export const APP_ROUTES = RouterModule.forRoot(appRoutes, { useHash: true });

